export default __webpack_public_path__ + "efbdeae59609cefba43642ce82e5cb3b.png";